MS = window.MS || {};

(function($) {

  var $window = $(window);
  var $document = $(document);
  var $html = $('html');
  var $body = $('body');

  MS.tableandsalt_store_locator = {

    init: function () {
      this.storePagination();
    },

    storePagination: function () {
      var items = $(".ms-ts-store-locator-result.stores .store");
      var numItems = items.length;
      var perPage = 8;
      items.slice(perPage).hide();

      if (numItems > perPage) {
        $('#pagination-container').pagination({
          items: numItems,
          itemsOnPage: perPage,
          prevText: "previous",
          nextText: "next",
          onPageClick: function (pageNumber) {
            var showFrom = perPage * (pageNumber - 1);
            var showTo = showFrom + perPage;
            items.hide().slice(showFrom, showTo).show();
            $('html, body').animate({
              scrollTop: $(".ms-ts-store-locator").offset().top
            }, 400)
          }
        });
      }
    }
  };

})(jQuery);
